/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandZeit = createReactComponent("outline", "brand-zeit", "IconBrandZeit", [["path", { "d": "M3 20h18l-9 -16z", "key": "svg-0" }]]);

export { IconBrandZeit as default };
//# sourceMappingURL=IconBrandZeit.mjs.map
